import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Film, Eye, Star, MessageSquare, CheckCircle } from 'lucide-react';

export default function Success() {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)' }}>
      <Navbar />
      <div style={{ maxWidth:520, margin:'0 auto', padding:'80px 24px', textAlign:'center' }} className="fade-up">
        <div style={{ width:72, height:72, borderRadius:'50%', background:'var(--pink-glow)', border:'2px solid var(--pink-glow-strong)', margin:'0 auto 22px', display:'flex', alignItems:'center', justifyContent:'center' }}>
          {state?.isEdit ? <Film size={30} color="var(--pink)" /> : <CheckCircle size={30} color="var(--pink)" />}
        </div>
        <h1 style={{ fontWeight:900, fontSize:32, color:'var(--text)', marginBottom:8, letterSpacing:'-0.02em' }}>
          {state?.isEdit ? 'Changes saved!' : 'Film submitted!'}
        </h1>
        <p style={{ color:'var(--text-secondary)', fontSize:15, marginBottom:4, fontWeight:400 }}>
          <strong style={{ color:'var(--text)', fontWeight:700 }}>{state?.title||'Your film'}</strong> {state?.isEdit ? 'has been updated.' : 'is in our queue.'}
        </p>
        <p style={{ color:'var(--text-muted)', fontSize:13, marginBottom:36, fontWeight:400 }}>
          {state?.isEdit ? 'Your changes are live on your dashboard.' : 'Track your review progress on the dashboard.'}
        </p>
        {!state?.isEdit && (
          <div className="card" style={{ padding:22, marginBottom:28, textAlign:'left' }}>
            <div className="section-label" style={{ marginBottom:16 }}>What happens next</div>
            {[
              [<Eye size={16} color="var(--pink)"/>,'Film Opened','Our team opens your submission within 1 hour automatically'],
              [<Star size={16} color="var(--pink)"/>,'Under Review','Anonymous scoring across 6 categories by our editorial team'],
              [<MessageSquare size={16} color="var(--pink)"/>,'Feedback Written','Honest, constructive notes are prepared anonymously'],
              [<CheckCircle size={16} color="var(--pink)"/>,'Decision','Approval or detailed feedback delivered to your dashboard'],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{ display:'flex', gap:12, marginBottom:14, alignItems:'flex-start' }}>
                <div style={{ width:34, height:34, borderRadius:10, background:'var(--bg-elevated)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{icon}</div>
                <div><div style={{ fontSize:13, fontWeight:700, color:'var(--text)', marginBottom:2 }}>{title}</div><div style={{ fontSize:12, color:'var(--text-muted)', fontWeight:400 }}>{desc}</div></div>
              </div>
            ))}
          </div>
        )}
        <div style={{ display:'flex', gap:10 }}>
          <button onClick={() => navigate('/dashboard')} className="btn-primary" style={{ flex:1 }}>Go to Dashboard</button>
          {!state?.isEdit && <button onClick={() => navigate('/submit')} className="btn-ghost" style={{ flex:1 }}>Submit Another</button>}
        </div>
      </div>
    </div>
  );
}
